import { TCondition } from '../types';
import { IApplicationState } from '../../../../types/types';
import { EHintKey, getHintConfig } from '../constants';
import { getAsidePanel } from '../../aside_panel/asidePanel/store/selectors/getAsidePanel';
import { getAuthUserSupport } from '../../../../store/model/authUser/selectors/getAuthUserSupport';
import { getAuthUser } from '../../../../store/model/authUser/selectors/getAuthUser';

export const gotoGoogleCalendarCondition: TCondition = (
    state: IApplicationState
) => {
    const hint = getHintConfig(EHintKey.GO_TO_GOOGLE_CALENDAR_HINT);
    if (!hint) return false;

    const isAsidePanelOpened = !!getAsidePanel(state).width;
    if (!isAsidePanelOpened) return false;

    const isSupportCalendarPush = getAuthUserSupport(state,'supportCalendarPush');
    if (!isSupportCalendarPush) return false;

    const isDropDownOpened = state.pushToGoogleCalendar && state.pushToGoogleCalendar.isDropDownOpened;
    if (!isDropDownOpened) return false

    const authUser = getAuthUser(state);

    return state.pushToGoogleCalendar.selectedElements && state.pushToGoogleCalendar.selectedElements.indexOf(authUser.email) > -1;
};
